import React, { useState } from "react";
import Draggable from "react-draggable";
import { IoBarChartOutline } from "react-icons/io5";
import Coin from "../../assets/images/coin.png";
import { LineChartWithArea } from "./chart";
import CumulativeReturnsChart from "./chart-2";
import ReloadIcon from "./../../assets/images/refresh.png";
import EquityCurveChart from "./chart-3";

export const LiveStatsModal = (props) => {
  const [netGain, setNetGain] = useState(
    props.data.total_profit_amount -
     
      props.data.total_bet_amount
  );

  console.log(props.data)


  return (
    <div
      style={{ zIndex: 99 }}
      tabIndex="-1"
      className="fixed inset-0 flex items-center justify-center pointer-events-none"
    >
      <Draggable handle=".drag-handle">
        <div className="relative p-4 w-full max-w-md border-1 border-transparent rounded-xl cursor-grab active:cursor-grabbing pointer-events-auto">
          <div className="relative bg-white rounded-lg shadow-sm dark:bg-gray-700">
            <div className="flex items-center justify-between p-4 md:p-5 border-b bg-202531 rounded-t border-gray-600 drag-handle cursor-move">
              <h3 className="text-lg text-white font-bold flex items-center">
                <IoBarChartOutline color="#fff" className="mr-2" />
                Live Stats
              </h3>
              <button
                type="button"
                className="text-white cursor-pointer"
                onClick={() => props.setOpenLiveStatModal(false)}
              >
                <svg
                  className="w-3 h-3"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 14"
                  onClick={() => props.setOpenLiveStatModal(false)}
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                  />
                </svg>
                <span
                  className="sr-only"
                  onClick={() => props.setOpenLiveStatModal(false)}
                >
                  Close modal
                </span>
              </button>
            </div>

            <div className="p-4 md:p-5 text-center bg-gray-900">
              <div className="grid justify-end mb-2 cursor-pointer" onClick={()=> {
                
                props.setRefreshGraph(!props.refreshGrap)}
                }>
                <img
                  src={ReloadIcon}
                  alt=""
                  className="border-1 bg-202531 rounded-t border-transparent rounded-lg p-1"
                />
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 p-2 bg-202531">
                <div className="bg-181D29 text-gray-400 border-1 border-transparent rounded-lg text-left p-2">
                  Net Gain
                  <div
                    className={`flex justify-between font-bold ${
                      netGain > 0 ? "text-green-500" : "text-red-500"
                    }`}
                  >
                    {netGain.toFixed(2)}
                    <img src={Coin} alt="coin" />
                  </div>
                </div>
                <div className="bg-181D29 text-gray-400 border-1 border-transparent rounded-lg text-left p-2">
                  Win Count
                  <div className="flex justify-between text-green-500 font-bold">
                    {props.data.total_win_count}
                  </div>
                </div>
                <div className="bg-181D29 text-gray-400 border-1 border-transparent rounded-lg text-left p-2">
                  Wagering Amount 
                  <div className="flex justify-between font-bold text-white">
                    {props.data.total_bet_amount}
                    <img src={Coin} alt="coin" />
                  </div>
                </div>
                <div className="bg-181D29 text-gray-400 border-1 border-transparent rounded-lg text-left p-2">
                  Losses
                  <div className="flex justify-between font-bold text-red-500">
                    {props.data.total_drops - props.data.total_win_count}
                  </div>
                </div>

                {/* <div className="bg-181D29 text-gray-400 border-1 border-transparent rounded-lg text-left p-2">
                  Wagering Amount
                  <div className="flex justify-between text-green-500 font-bold">
                    00
                  </div>
                </div> */}
              </div>

              <div className="p-2 bg-202531">
                {/* <CumulativeReturnsChart financeChart={props.financeChart} /> */}
                <EquityCurveChart financeChart={props.financeChart} />
              </div>
            </div>
          </div>
        </div>
      </Draggable>
    </div>
  );
};
